import { render, staticRenderFns } from "./purchaseRoutePrice-add-or-update.vue?vue&type=template&id=13a66852&scoped=true"
import script from "./purchaseRoutePrice-add-or-update.vue?vue&type=script&lang=js"
export * from "./purchaseRoutePrice-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./purchaseRoutePrice-add-or-update.vue?vue&type=style&index=0&id=13a66852&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a66852",
  null
  
)

export default component.exports